import React from "react";
import { ScrollBarSpacer, ScrollWindow } from './Scrollview.styles';
import { ScrollviewProps } from './Scrollview.types';

export const Scrollview: React.FC<ScrollviewProps> = ({ maxsize = 200, children }) => {
  return (
    <ScrollWindow maxsize={maxsize} autoHide={false}>
      <ScrollBarSpacer>
        {children}
      </ScrollBarSpacer>
    </ScrollWindow>
  )
}